import request from '@hb/sharp-request';
import requestDefault from '@/shared/utils/request';
import { OrdersPo } from '@/po/orders';
import { newGatewayUrl } from '@/constant';

// 我的订单列表页面, 只显示臻有钱
export const getOrdersList = (
  state: string | number,
): Promise<OrdersPo.MyOrderResponse[]> => request
  .postGate<OrdersPo.MyOrderResponse[]>('f.order.orderList', {
    state,
  }, { baseURL: newGatewayUrl })
  .then((orderList) => orderList.filter(
    (item) => Number(item.productId) === 2000 && item.state === 'LENT',
  ));

// 查询订单
export const queryOrders = (
  loanOrderId: string,
): Promise<OrdersPo.QueryOrder> => requestDefault.postGate('f.order.query.info', { loanOrderId });


// 获取中断订单信息
export const getBrokenStatus = (params:{
  productId?: string;
  productIdList?: string[];
}):
Promise<{
  loanOrderId: string,
  popWindow:boolean,
  amount:number,
  canCancel: boolean,
  productId: string,
}> => requestDefault.postGate(
  'f.order.brokenStatus.check',
  { ...params },
);

const OrdersApi = {
  getOrdersList,
  queryOrders,
  getBrokenStatus,
};

export default OrdersApi;
